<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="登录地址" prop="ipaddr">
        <el-input v-model="queryParams.ipaddr" placeholder="请输入登录地址" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="用户名称" prop="userName">
        <el-input v-model="queryParams.userName" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="登录状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="登录状态" clearable  >
              <el-option v-for="dict in dict.type.sys_log_status" :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="登录方式" prop="loginType">
        <el-select v-model="queryParams.loginType" placeholder="登录方式" clearable  >
          <el-option v-for="dict in dict.type.login_type" :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="登录设备" prop="deviceName">
          <el-input v-model="queryParams.deviceName" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="操作系统" prop="os">
          <el-input v-model="queryParams.os" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="代理名称" prop="agentName">
          <el-input v-model="queryParams.agentName" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="登录时间" >
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="-"
                        start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
      </el-form-item>
      <el-form-item label="提示信息" prop="msg">
        <el-input v-model="queryParams.msg" placeholder="请输入提示信息" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['monitor:logininfor:remove']" type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple" @click="handleDelete">删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['monitor:logininfor:clean']" type="danger" plain icon="el-icon-delete" size="mini" @click="handleClean">清空</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['monitor:logininfor:unlock']" type="primary" plain icon="el-icon-unlock" size="mini" :disabled="single" @click="handleUnlock">解锁</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <el-table ref="tables" v-loading="loading" :data="list" @selection-change="handleSelectionChange" :default-sort="defaultSort" @sort-change="handleSortChange">
      <el-table-column type="selection" width="55px" align="center" />
      <el-table-column label="访问编号" align="center" prop="logId" width="70px"/>
      <el-table-column label="用户名称" align="center" prop="userName" min-width="150px" :show-overflow-tooltip="true" sortable="custom" :sort-orders="['descending', 'ascending']" />
      <el-table-column label="登录方式" align="center" prop="loginType" width="90px">
        <template slot-scope="scope">
          <dict-tag :options="dict.type.login_type" :value="scope.row.loginType"/>
        </template>
      </el-table-column>
      <el-table-column label="登录IP" align="center" prop="ipaddr" width="130px" :show-overflow-tooltip="true" />
      <el-table-column label="登录地点" align="center" prop="loginLocation" min-width="100px" :show-overflow-tooltip="true" />
      <el-table-column label="设备类型" align="center" prop="deviceType" width="90px" :show-overflow-tooltip="true" />
      <el-table-column label="设备名称" align="center" prop="deviceName" min-width="130px" :show-overflow-tooltip="true" />
      <el-table-column label="操作系统" align="center" prop="os" min-width="110px"/>
      <el-table-column label="代理类型" align="center" prop="agentType" min-width="100px" :show-overflow-tooltip="true" />
      <el-table-column label="代理名称" align="center" prop="agentName" min-width="150px" :show-overflow-tooltip="true" />
      <el-table-column label="登录状态" align="center" prop="status" width="90px">
        <template slot-scope="scope">
          <dict-tag :options="dict.type.sys_log_status" :value="scope.row.status"/>
        </template>
      </el-table-column>
      <el-table-column label="提示信息" align="center" prop="msg" width="90px"/>
      <el-table-column label="登录时间" align="center" prop="loginTime" sortable="custom" :sort-orders="['descending', 'ascending']" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.loginTime | dateTime }} </span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { list, delLoginLog, cleanLoginLog,unlockLogin} from "@/api/log/loginlog";

export default {
  name: "LoginInfor",
  dicts:["sys_log_status","login_type"],
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 选择用户名
      selectName: "",
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 表格数据
      list: [],
      // 日期范围
      dateRange: [],
      // 默认排序
      defaultSort: {prop: "loginTime", order: "descending"},
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        ipaddr: undefined,
        userName: undefined,
        deviceName: undefined,
        os: undefined,
        agentName: undefined,
        status: undefined,
        msg: undefined,
      },
      options: [
        {label:'成功',value:0},
        {label:'失败',value:1},
      ]
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询登录日志列表 */
    getList() {
      this.loading = true;
      if( Array.isArray(this.dateRange) && this.dateRange.length>0){
        this.queryParams.startTime=this.dateRange[0];
        this.queryParams.endTime=this.dateRange[1];
      }
      list(this.queryParams).then(res => {
          this.list = res.rows;
          this.total = res.total;
          this.loading = false;
        }
      );
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryParams.startTime=undefined;
      this.queryParams.endTime=undefined;
      this.resetForm("queryForm");
      this.queryParams.current = 1;
      this.$refs.tables.sort(this.defaultSort.prop, this.defaultSort.order)
    },
    /** 多选框选中数据 */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.logId)
      this.single = selection.length!=1
      this.multiple = !selection.length
      this.selectName = selection.map(item => item.userName);
    },
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let ids = this.ids;
      if (row.logId) {
        ids = [row.logId];
      }

      this.$modal.confirm('是否确认删除访问编号为"' + ids + '"的数据项？').then(function() {
        return delLoginLog({ ids: ids });
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 清空按钮操作 */
    handleClean() {
      this.$modal.confirm('是否确认清空所有登录日志数据项？').then(function() {
        return cleanLoginLog();
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("清空成功");
      }).catch(() => {});
    },
    /** 解锁按钮操作 */
    handleUnlock() {
      const username = this.selectName;
      this.$modal.confirm('是否确认解锁用户"' + username + '"数据项?').then(function() {
        return unlockLogin(username);
      }).then(() => {
        this.$modal.msgSuccess("用户" + username + "解锁成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('monitor/logininfor/export', {
        ...this.queryParams
      }, `logininfor_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>

